<template>
  <el-dialog
    top="10vh"
    class="edit-dialog"
    title="详情"
    width="560px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="close"
    :visible.sync="dialogVisible"
  >
    <div>
      <el-form ref="form" :model="form" label-width="120px" size="small">
        <el-form-item label="角色名称:" prop="name">
          {{ form.name }}
        </el-form-item>
        <el-form-item label="状态:" prop="state">
          <hl-tag :style="{ ...YNColor[form.state] }">{{ form.stateName }}</hl-tag>
        </el-form-item>
        <el-form-item label=":" prop="description">
          <div class="detail-role-container" v-loading="loading">
            <el-tree
              ref="tree"
              :data="data"
              :filter-node-method="filterNode"
              default-expand-all
              node-key="id"
              :props="{
                label: 'name',
                children: 'childList'
              }"
            ></el-tree>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
// import menu from '@manage/components/SiderMenu/menus'
import Tag from '@manage/components/CommonTable/Tag'
import { YNColor } from '@manage/config/StateColorEmun'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: Object
  },
  components: {
    'hl-tag': Tag
  },
  data() {
    return {
      YNColor,
      dialogVisible: this.visible,
      data: [],
      loading: false,
      form: {
        id: '',
        name: '',
        state: 'Y',
        description: ''
      }
    }
  },
  created() {
    if (this.row.id) {
      let params = {
        id: this.row.id
      }
      this.loading = true
      this.$ajax.get(this.$api.system.role_detail, params).then((res) => {
        this.form = res.data
        this.data = res.data.menuTreeDtos
        this.$nextTick(() => {
          this.$refs.tree.filter()
          this.loading = false
        })
      })
    }
  },
  methods: {
    filterNode(value, data) {
      return data.isPermission == 'Y'
    },
    close() {
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style lang="less" scoped>
.edit-dialog {
  .detail-role-container {
    width: 340px;
    border-radius: 8px;
    padding: 15px;
    height: 400px;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 3px;
      height: 10px;
    }
    &::-webkit-scrollbar-track {
      background: #ffffff;
      border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb {
      background: #ccc;
      border-radius: 4px;
    }
  }
}
</style>
